import React from "react";

const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

// Wraps the portion of `text` matching `searchTerm` (case-insensitive) in
// <mark>. Renders plain text unchanged when there's no term or no match.
const HighlightText = ({ text, searchTerm }) => {
  if (text === undefined || text === null || text === "") return null;
  const value = String(text);

  const term = (searchTerm || "").trim();
  if (!term) return value;

  const escaped = escapeRegExp(term);
  const parts = value.split(new RegExp(`(${escaped})`, "gi"));
  if (parts.length === 1) return value;

  return parts.map((part, i) =>
    part.toLowerCase() === term.toLowerCase() ? (
      <mark key={i} style={{ backgroundColor: "#fff59d", padding: 0 }}>
        {part}
      </mark>
    ) : (
      part
    )
  );
};

export default HighlightText;
